import { cn } from "@/lib/utils";

/** Small trend line for a vital (two series for BP), with the normal band shaded when known. */
export default function Sparkline({ series, low, high }: { series: number[][]; low?: number | null; high?: number | null }) {
    const W = 120, H = 34, P = 3;
    const all = series.flat();
    // A trend needs at least two readings of the same vital
    if (Math.max(...series.map(s => s.length)) < 2) return null;
    let min = Math.min(...all), max = Math.max(...all);
    if (low != null) min = Math.min(min, low);
    if (high != null) max = Math.max(max, high);
    if (max === min) { max += 1; min -= 1; }
    const y = (v: number) => H - P - ((v - min) / (max - min)) * (H - 2 * P);
    const n = Math.max(...series.map(s => s.length));
    const x = (i: number) => P + (n === 1 ? 0 : (i / (n - 1)) * (W - 2 * P));
    return (
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-[34px]" preserveAspectRatio="none" aria-hidden="true">
            {low != null && high != null && (
                <rect x={0} y={y(high)} width={W} height={Math.max(0, y(low) - y(high))} className="fill-success/10" />
            )}
            {series.map((s, si) => (
                <g key={si}>
                    <polyline
                        points={s.map((v, i) => `${x(i)},${y(v)}`).join(" ")}
                        className={cn("fill-none", si === 0 ? "stroke-primary" : "stroke-primary/45")}
                        strokeWidth={1.5} vectorEffect="non-scaling-stroke" strokeLinejoin="round"
                    />
                    <circle cx={x(s.length - 1)} cy={y(s[s.length - 1])} r={2.2} className="fill-primary" />
                </g>
            ))}
        </svg>
    );
}
